import { ConcreteMixDesigns } from '../../../cimsPage/instances/materials'
import { Simple } from '../../common'

const object = 'Concrete Mix Design'
const page = ConcreteMixDesigns

export const CreateConcreteMixDesign = Simple({
  id: 'B7DE6227-A866-4352-AF9E-F23608B8BA92',
  action: 'Create',
  object,
  page,
})

export const EditConcreteMixDesign = Simple({
  id: '2CAE03E9-CABD-491A-A67A-4EBA149ECBB7',
  action: 'Edit',
  object,
  page,
})

export const ViewConcreteMixDesign = Simple({
  id: '2D5C8425-BF44-489A-AE21-29EE3C27E6FB',
  action: 'View',
  object,
  page,
})

export type ConcreteMixDesignPermissionItem =
  | typeof CreateConcreteMixDesign
  | typeof EditConcreteMixDesign
  | typeof ViewConcreteMixDesign
